<div class="cov-form">
  <!-- Read-only, pre-scoped service chip (upload dialog). The edit/link dialog
       hides this (showServiceContext=false) and renders its own
       requirement-derived "Applies to" context. -->
  <div class="cov-form__field" *ngIf="showServiceContext && service">
    <label class="cov-form__label">Service</label>
    <div class="cov-form__service-chip">
      <span class="material-icons">home_repair_service</span>
      <span class="cov-form__service-chip-text">
        {{
          scopedSubType
            ? service.displayName + " — " + scopedSubType.displayName
            : service.displayName
        }}
      </span>
    </div>
  </div>

  <!-- "Also apply to sub-services" blanket checkboxes -->
  <div class="cov-form__field" *ngIf="showServiceContext && siblings.length > 0">
    <label class="cov-form__label">Also apply to sub-services</label>
    <div class="cov-form__checkbox" *ngFor="let sibling of siblings">
      <input
        type="checkbox"
        [attr.data-testid]="'cov-form-sibling-' + siblingTestKey(sibling)"
        [(ngModel)]="sibling.checked"
        (ngModelChange)="onChange()"
      />
      <label>
        {{ sibling.displayName }}
        <span
          *ngIf="sibling.noLongerRequired"
          class="cov-form__sub-note"
          title="This sub-service no longer requires a document, but this document currently covers it."
          >(no longer required)</span
        >
      </label>
    </div>
  </div>

  <!-- Issue date. Mirrors expiration: always shown in legacy mode (the edit
       dialog), only when required in strict license-driven mode (upload). The
       required asterisk shows only when the license requires an issue date, so it
       can be set optionally too. Reuses the same plain bordered datepicker field
       as expiration. -->
  <div class="cov-form__field" *ngIf="showIssue">
    <label class="cov-form__label" for="cov-form-issue">
      Issue Date
      <span *ngIf="issueDateRequired" class="cov-form__required" aria-hidden="true">*</span>
    </label>
    <div class="cov-form__date">
      <input
        id="cov-form-issue"
        #issueInput
        class="cov-form__date-input"
        data-testid="cov-form-issue-date"
        [matDatepicker]="issuePicker"
        [(ngModel)]="issueDate"
        (ngModelChange)="onChange()"
        (keydown)="onIssueKeydown($event)"
        (paste)="onIssuePaste()"
        (blur)="onIssueBlur()"
        placeholder="mm/dd/yyyy"
      />
      <mat-datepicker-toggle
        class="cov-form__date-toggle"
        data-testid="cov-form-issue-date-toggle"
        [for]="issuePicker"
      ></mat-datepicker-toggle>
      <mat-datepicker #issuePicker />
    </div>
  </div>

  <!-- Expiration date. Plain bordered field (matching the prior native control);
       the Material datepicker only supplies the styled calendar popup, whose look
       comes from the global Material theme (same as the Schedule Site Visit
       calendar) with no per-field chrome. Required marker driven by the license. -->
  <div class="cov-form__field" *ngIf="showExpiration">
    <label class="cov-form__label" for="cov-form-expiration">
      Expiration Date
      <span *ngIf="expirationDateRequired" class="cov-form__required" aria-hidden="true">*</span>
    </label>
    <div class="cov-form__date">
      <input
        id="cov-form-expiration"
        #expirationInput
        class="cov-form__date-input"
        data-testid="cov-form-expiration-date"
        [matDatepicker]="expirationPicker"
        [(ngModel)]="expirationDate"
        (ngModelChange)="onChange()"
        (keydown)="onExpirationKeydown($event)"
        (paste)="onExpirationPaste()"
        (blur)="onExpirationBlur()"
        placeholder="mm/dd/yyyy"
      />
      <mat-datepicker-toggle
        class="cov-form__date-toggle"
        data-testid="cov-form-expiration-date-toggle"
        [for]="expirationPicker"
      ></mat-datepicker-toggle>
      <mat-datepicker #expirationPicker />
    </div>
  </div>
</div>
